export const isTxTrackerSetupAvailable = ({
  isOtherTreatment,
  isAlignersTreatment,
  isBracesTreatment,
  isRetentionStatus,
  isAlignersTrackerEnabled,
  isBracesTrackerEnabled,
  isRetentionTrackerEnabled
}) => {
  const isActiveTrackerAvailable =
    !isOtherTreatment &&
    ((isAlignersTreatment && isAlignersTrackerEnabled) || (isBracesTreatment && isBracesTrackerEnabled))

  const isRetentionTrackerAvailable = isRetentionStatus && isRetentionTrackerEnabled

  return !!(isActiveTrackerAvailable || isRetentionTrackerAvailable)
}
